export default "__VITE_ASSET__6e65a471__"